module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/img_title_nagai-0fa3a2bbb543299c3d5886aaf7690d36.jpg";